var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('Sidebar',{directives:[{name:"touch",rawName:"v-touch:swipe.left",value:(_vm.swipeHandler),expression:"swipeHandler",arg:"swipe",modifiers:{"left":true}}],ref:"sideBarRef",attrs:{"id":"sideBarId"}})],1),_c('router-view',{staticClass:"page",class:{ pageoffset: true }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }